import { toast } from 'react-toastify';

const toastOptions = message => {
  const getToastTimeout = () => {
    let timeout = 150 * message?.length ?? 0;
    if (timeout < 4000) {
      return 4000;
    } else if (timeout > 15000) {
      timeout = 15000;
    }
    return timeout;
  };
  return {
    position: 'top-center',
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    autoClose: getToastTimeout()
  };
};

export const customToast = (message, type = '', options = {}) => {
  switch (type) {
    case 'info':
      toast.info(message, {
        ...toastOptions(message),
        ...options,
        toastId: 'infoToast'
      });
      break;
    case 'error':
      toast.error(message, {
        ...toastOptions(message),
        ...options
      });
      break;
    default:
      toast.success(message, {
        ...toastOptions(message),
        ...options
      });
      break;
  }
};

export default customToast;
